import { createApiCall } from 'lib/base';

const FETCH_INVESTCORE_VCAM_ACCOUNT_CREATE_API_ID =
  'DASHBOARD/FETCH_INVESTCORE_VCAM_ACCOUNT_CREATE_API';

export const createVcamAccount = createApiCall(
  FETCH_INVESTCORE_VCAM_ACCOUNT_CREATE_API_ID,
  ({ id, payload }) => ({
    endpoint: `/api/admin/users/${id}/vcam/create-account`,
    method: 'POST',
    body: payload,
    notify: true,
  })
);
